import React, { ReactNode } from 'react';
import styled from 'styled-components';

import { Spinner } from '@/components/shared/Spinner';

type Props = {
  children?: ReactNode;
};

export const LoaderWithDimmer: React.FC<Props> = ({ children }) => (
  <Wrapper>
    <div className="inner">
      <Spinner />
      <div className="loading-text">Loading</div>
      {children && <div className="prop-text">{children}</div>}
    </div>
  </Wrapper>
);

const Wrapper = styled.div`
  position: fixed;
  inset: 0;
  z-index: 105;
  opacity: 1;
  display: grid;
  place-items: center;
  background-color: rgba(255, 255, 255, 0.85);

  .inner {
    display: grid;
    place-items: center;
  }

  .loading-text {
    margin-top: 7px;
  }

  .prop-text {
    margin-top: 30px;
    color: rgba(0, 0, 0, 0.87);
    line-height: 22.4px;
    text-align: center;
  }
`;
